export const SET_PRIMARY_DASHBOARD = 'EPIC/DASH_SET_PRIMARY';
export const SET_PRIMARY_DASHBOARD_SUCCESS = 'EPIC/DASH_SET_PRIMARY_SUCCESS';
export const SET_PRIMARY_DASHBOARD_FAILURE = 'EPIC/DASH_SET_PRIMARY_FAILURE';
